/**
 * Generated by Orval
 * Do not edit manually.
 */
import type { GetPhoneNumber200, GetPhoneNumberParams, GetTrackablePhoneNumbers200 } from '../index.schemas.ts';

import { apiFetch } from '../../../utils/fetch.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Get trackable inbound phone number for the specified title
 */
export const getTrackablePhoneNumbers = (
  title: string,
  options?: SecondParameter<typeof apiFetch<GetTrackablePhoneNumbers200>>,
) => {
  return apiFetch<GetTrackablePhoneNumbers200>(
    { url: `/front-office/v1/calltracking-phone-number/${title}`, method: 'GET' },
    options,
  );
};
/**
 * @summary Get inbound phone number for the specified title
 */
export const getPhoneNumber = (
  params: GetPhoneNumberParams,
  options?: SecondParameter<typeof apiFetch<GetPhoneNumber200>>,
) => {
  return apiFetch<GetPhoneNumber200>({ url: `/front-office/v2/phone-numbers`, method: 'GET', params }, options);
};
export type GetTrackablePhoneNumbersResult = NonNullable<Awaited<ReturnType<typeof getTrackablePhoneNumbers>>>;
export type GetPhoneNumberResult = NonNullable<Awaited<ReturnType<typeof getPhoneNumber>>>;
